import React from 'react';
import styles from './FeatureHeader.module.css';

const FeatureHeader = () => {
    return (
        <div
            role="presentation"
            className={styles.featureHeader}
        >
            <div className={styles.headerOverlay}></div>
            <div className={styles.titleContainer}>
                <h2 className={styles.title}>
                    Build your cl!que
                </h2>
            </div>
            <div className={styles.iconContainer}>
                <div className={styles.iconBackground}>
                    <img
                        src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-10.svg"
                        alt="Icon"
                        className={styles.iconImage}
                    />
                </div>
            </div>
            <div className={styles.subtitleContainer}>
                <p className={styles.subtitle}>
                    <span className={styles.subtitleSpan}>
                        Get personalized messages from your favourite{' '}
                        <span className={styles.boldText}>
                            stars &amp; celebs
                        </span>
                    </span>
                </p>
            </div>
        </div>
    );
};

export default FeatureHeader;